module.exports = __webpack_public_path__ + "img/honor2.e5d26e2.png";